import React, { useEffect, useState } from "react";
import "./animated.css";

export default function AnimatedLoader({ position }) {
  const [speed, setSpeed] = useState(60);

  // Simulate increasing speed effect
  useEffect(() => {
    let interval = setInterval(() => {
      setSpeed((prev) => (prev < 100 ? prev + 10 : 0));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const needleRotation = (speed / 100) * 180 - 90;

  return (
    <div
      className={`${
        position === "nocenter" ? "notcenter-loader" : "center-loader"
      }`}
    >
      {/* App Name */}
      <h1 className="app-name">
        <i>SPOT FLASH</i>
      </h1>

      {/* Speedometer Container */}
      <div className="semi-gauge-container">
        <div className="semi-gauge">
          {/* White Center of Semi-Circle */}
          <div className="semi-gauge-overlay"></div>
          {/* Needle */}
          <div
            className="semi-needle"
            style={{ transform: `rotate(${needleRotation}deg)` }}
          ></div>
          {/* Center Circle */}
          <div className="semi-gauge-center"></div>
        </div>
        <p className="speed-text">{speed} Knots</p>

      </div>
    <h5 className="mt-2  "  >Edkas</h5>
    </div>
  );
}
